import { render, staticRenderFns } from "./AppSplitter.vue?vue&type=template&id=06c24692&"
import script from "./AppSplitter.vue?vue&type=script&lang=js&"
export * from "./AppSplitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports